import React from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { trackCtaClick } from "../../../ga-utils";
import { STATIC_KEYWORDS } from "../../../constants";
import { Button } from "../../atoms";

import "./readEmagazineBlack.m.css";

const ReadEmagazineBlack = ({ magazineWidget }) => {
  const { emagazineLink, emagazineImageUrlHome } = magazineWidget;
  const { READ_EMAGAZINE_BLACK, READ_EMAGAZINE } = STATIC_KEYWORDS;
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], {}));
  const trackReadMagClick = () => {
    if (typeof window !== "undefined") {
      trackCtaClick({
        linkUrl: emagazineLink,
        linkText: READ_EMAGAZINE?.toLowerCase(),
        pageType: pageType,
        location: window.location,
      });
    }
  };
  return (
    <div styleName="ad-free-container">
      <div styleName="content-div">
        <div styleName="go-ad-free-text">{READ_EMAGAZINE_BLACK}</div>
        <a href={emagazineLink} target="_blank" rel="noopener noreferrer" onClick={trackReadMagClick}>
          <Button customStyleName="go-ad-free-btn">{READ_EMAGAZINE}</Button>
        </a>
        <span
          styleName="background-svg"
          style={{
            backgroundImage: `url(${emagazineImageUrlHome})`,
            backgroundSize: "78%",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "1px 7px",
          }}
        ></span>
      </div>
    </div>
  );
};

export default ReadEmagazineBlack;
